import React, { useEffect, useState } from 'react'
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';


const InSchedulelayout = ({
  EditAccess = false,
  children,
}) => {
  const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const fromDashboard = location.state?.fromDashboard === true;

  let { pathname } = useLocation();
  const [module, setModule] = useState("");
  const { scheduleViewId} = useParams();

  const from = location.state?.from || -1; 

  console.log("from",from);

  

  const [, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (pathname == `/inspection/schedule/view/${scheduleViewId}`) {
      setModule("Details");
    }
    else if (
        pathname == `/inspection/schedule/newform/${scheduleViewId}`
      ) {
        setModule("Inspection Forms");
      }

        else if (
        pathname == `/inspection/schedule/generator/${scheduleViewId}`
      ) {
        setModule("Generator");
      }

      
  }, [pathname]);

  let LinkItem = [
    {
      label: "Details",
      link: `/inspection/schedule/view/${scheduleViewId}`,
      access: true,
    },
    {
        label: "Inspection Forms",
  
        link: `/inspection/schedule/newform/${scheduleViewId}`,
        access: GetAccess(),
      },


  ];

  

  return (
    <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
      <div className="flex justify-between w-full ">
       
       
        <div className="sm:flex justify-between w-full">
        <Breadcrumb
          items={[
            {
              name: "Schedule",
              link:"/inspection/schedule"

             
            },

            { name: module },
          ]}
        />
 <div className=" flex gap-2 justify-end">

            {/* <BackButton
                link={true}
                hasLink={
                  fromDashboard
                    ? "/dashboard"
                    : module === "Inspection Forms"
                    ? `/inspection/schedule/view/${scheduleViewId}`
                 
                    : module !== "Details"
                    ? `/inspection/schedule`
                       : `/inspection/schedule`
                }
                state={
                  !fromDashboard && module === "Details"
                    ? {
                        currentPage: pageIndex,
                        searchQuery: searchQuery !== "" ? searchQuery : "",
                      }
                    : null
                }
              /> */}
              <BackButton
              link={true}
                hasLink={
                        `/inspection/schedule`
                }/>

            {EditAccess && (
              <Link
                to={`/inspection/schedule/edit/${scheduleViewId}`}
                state={{
                  data: data,
                  from: `/inspection/schedule/view/${scheduleViewId}`,
                }}
              >
                <EditButton
                 height="8" />
              </Link>
            )}
          </div>
       
        </div>
      </div>
      <div className=" w-full  flex items-center gap-x-1 ">
          {LinkItem &&
            LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;

              return (
                <>
                  {item.access && (

                      <Link
                                                                                                    to={item?.link}
                                                                                                    key={item?.link}
                                                                                                    state={{fromDashboard:fromDashboard}}
                                                                                                    className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                                                                                      ${isActive 
                                                                                                        ? "bg-baseColor-primary text-white" 
                                                                                                        : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                                                                                      }`}
                                                                                                  >
                                                                                                    {item?.label || ""}
                                                                                                  </Link>
             
                  )}
                </>
              );
            })}
        </div>
      <div className=" w-full h-[calc(100vh-160px)]  ">{children}</div>
    </div>
  );
};



export default InSchedulelayout